export const AREE = {
  AREA_018_ANNI: 'A018',
};
